// extracted by mini-css-extract-plugin
export var messageSideLeft = "_os-1";
export var messageSideRight = "_os-2";
export var orderLookupBubbleContainer = "_os-0";
export var submitButton = "_os-3";